<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :indexNested="true"
    :disablePagination="true"
    :maskFields="maskFields"
    :callback="callback"
  >

    <template slot="new">
      <v-dialog
        :scrollable="true"
        persistent
        :fullscreen="true"
        v-if="$vuetify.breakpoint.smAndDown"
        v-model="dialogModel"
        @keydown.esc="dialogCancelAction"
      >
        <v-overlay :value="pageLoading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div v-if="loading">
          <v-skeleton-loader
            class="mx-auto d-none d-sm-block"
            type="article, actions"
          ></v-skeleton-loader>

          <v-skeleton-loader
            class="mx-auto d-sm-none"
            type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
          ></v-skeleton-loader>
        </div>
        <v-card v-else>
          <v-card-title>
            <span class="h4">Novo Ajuste de Colheita</span>
            <v-spacer></v-spacer>
              <v-btn
                text
                icon
                title="Cancelar"
                class="my-2"
                @click="dialogCancelAction"
              >
                <v-icon right dark>mdi-close-circle</v-icon>
              </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text id="dialogBody">

            <v-list
              :flat="false"
              :dense="false"
              class="mt-5"
            >
              <v-list-item-group
                :multiple="false"
                color="success"
              >
                
                <v-divider
                  key="divider-1"
                />
                <v-list-item
                  key="list-item-1"
                  @click="exitStorageAdjustmentOpenAction"
                  :two-line="false"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-table-minus</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="title">Ajuste de Saída</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider
                  key="divider-2"
                />
                <v-list-item
                  key="list-item-2"
                  @click="entryStorageAdjustmentOpenAction"
                  :two-line="false"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-table-plus</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="title">Ajuste de Entrada</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                
                <v-divider
                  key="divider-last"
                />
                
              </v-list-item-group>
            </v-list>

            <ExitStorageAdjustmentNew
              @entry-created="entryCreated"
              modelNameSingular="Ajuste de Saída de Colheita"
              :entry="entry"
              ref="exitStorageAdjustmentNewRef"
            />

            <EntryStorageAdjustmentNew
              @entry-created="entryCreated"
              modelNameSingular="Ajuste de Entrada de Colheita"              
              :entry="entry"
              ref="entryStorageAdjustmentNewRef"
            /> 

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn class="my-2" @click="dialogCancelAction">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
        <template v-slot:activator="{ on: dialog }" @open-dialog="dialogOpenAction">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                color="primary"
                class="ma-1 d-none d-md-flex"
                v-on="{ ...tooltip, ...dialog }"
                @click="dialogOpenAction"
                :disabled="false">
                  Adicionar Ajuste de Colheita
                <v-icon right dark>mdi-plus</v-icon>
              </v-btn>

              <v-btn
                class="d-md-none"
                color="primary"
                absolute
                right
                fab
                v-on="{ ...dialog }"
                @click="dialogOpenAction"
                :disabled="false"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>

            </template>
            <span>Criar Ajuste de Colheita</span>
          </v-tooltip>
        </template>
      </v-dialog>

      <!-- <ExitStorageAdjustmentNew
        @entry-created="entryCreated"
        modelNameSingular="Ajuste de Saída de Colheita"
      />

      <EntryStorageAdjustmentNew        
        @entry-created="entryCreated"
        modelNameSingular="Ajuste de Entrada de Colheita"
      /> -->

    </template>
    
    <template slot="new">
      <ExitStorageAdjustmentNew
        @entry-created="entryCreated"
        modelNameSingular="Saída"
        :entry="entry"
      />

      <EntryStorageAdjustmentNew
        @entry-created="entryCreated"
        modelNameSingular="Entrada"
        :entry="entry"
      />
    </template>


    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <ExitStorageAdjustmentEdit v-if="item.isStockEntryType == false"
        :entry="item"
        :readOnly="true"
        modelNameSingular="Saída"
      />

      <EntryStorageAdjustmentEdit v-if="item.isStockEntryType == true"
        :entry="item"
        :readOnly="true"
        modelNameSingular="Entrada"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <ExitStorageAdjustmentEdit v-if="item.isStockEntryType == false"
        :entry="item"
        @entry-updated="entryUpdated"
        modelNameSingular="Saída"
        :isEdit="true"
      />
      
      <EntryStorageAdjustmentEdit v-if="item.isStockEntryType == true"
        :entry="item"
        @entry-updated="entryUpdated"
        modelNameSingular="Entrada"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <ExitStorageAdjustmentDelete v-if="item.isStockEntryType == false"
        :entry="item"
        @entry-destroyed="entryDeleted"
        modelNameSingular="Saída"
      />
      
      <EntryStorageAdjustmentDelete v-if="item.isStockEntryType == true"
        :entry="item"
        @entry-destroyed="entryDeleted"
        modelNameSingular="Entrada"
      />
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import ExitStorageAdjustmentNew from "./exit_storage_adjustments/new.vue";
import ExitStorageAdjustmentEdit from "./exit_storage_adjustments/edit.vue";
import ExitStorageAdjustmentDelete from "./exit_storage_adjustments/delete.vue";
import EntryStorageAdjustmentNew from "./entry_storage_adjustments/new.vue";
import EntryStorageAdjustmentEdit from "./entry_storage_adjustments/edit.vue";
import EntryStorageAdjustmentDelete from "./entry_storage_adjustments/delete.vue";

export default {
  data() {
    return {
      dialogModel: false,
      exitStorageAdjustmentNewDialog: false,
      entryStorageAdjustmentNewDialog: false,
      // indexItems: [],
      loading: false,
      pageLoading: false,
      totalItems: 0,
      crop: {},
      tableHeaders: [
        //trocar id para code depois que vier a coluna
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Data", align: "left", sortable: true, value: "date" },
        { text: "Estoque", align: "left", sortable: true, value: "storage.name" },
        // { text: "Motivo", align: "left", sortable: true, value: "stockAdjustmentReason.name" },
        { text: "Tipo de Ajuste", align: "left", sortable: true, value: "adjustmentTypeText" },
        { text: "Qtd Entrada", align: "left", sortable: true, value: "entryQuantity" },
        { text: "Qtd Saída", align: "left", sortable: true, value: "exitQuantity" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'date', mask: 'date'},
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    entry: Object,
    modelNameSingular: {
      type: String,
      default: "Ajuste de Colheita"
    },
    callback: {
      type: Function,
      default: void(0),
    },
    indexItems: {
      type: Array,
      default: function(){return []},
    },
    modelNamePlural: {
      type: String,
      default: "Ajustes de Colheita"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    ExitStorageAdjustmentNew: ExitStorageAdjustmentNew,
    ExitStorageAdjustmentEdit: ExitStorageAdjustmentEdit,
    ExitStorageAdjustmentDelete: ExitStorageAdjustmentDelete,
    EntryStorageAdjustmentNew: EntryStorageAdjustmentNew,
    EntryStorageAdjustmentEdit: EntryStorageAdjustmentEdit,
    EntryStorageAdjustmentDelete: EntryStorageAdjustmentDelete,
  },
  created() {
    // this.loadServerEntries();
    this.crop = this.entry;
    
    // console.log("entr", this.entry);
    // console.log("eix", this.crop.exitMovementItemsAttributes);    
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      // this.loadServerEntries();
    },
    // loadServerEntries: function() {
    //   this.loading = true;
    //   this.$apollo
    //     .query({
    //       query: LOAD_ALL_STORAGE_ADJUSTMENTS,
    //       variables: {
    //         input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
    //           limit: this.options.itemsPerPage,
    //           offset: (this.options.page - 1) * this.options.itemsPerPage,
    //           sortBy: this.options.sortBy,
    //           sortDesc: this.options.sortDesc,
    //           fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
    //           filters: this.filters
    //         }
    //       },
    //       fetchPolicy: "no-cache"
    //     })
    //     .then(response => {
    //       // this.fields = response.data.groundContext.fieldsIndex.fields;
    //       //console.log("All fields", this.fields);
    //       this.indexItems = response.data.accountContext.storageAdjustmentsIndex.stockAdjustments; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
    //       this.totalItems = response.data.accountContext.storageAdjustmentsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
    //       this.typeOperators = response.data.accountContext.storageAdjustmentsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
    //       this.serverFields = response.data.accountContext.storageAdjustmentsIndex.serverFields; // seta os campos que podem ser filtrados
    //     })
    //     .catch(response => console.log(response))
    //     .finally(() => (this.loading = false));
    // },
    entryUpdated: function(params){
      // this.loadServerEntries();
      console.log("params", params);
      // params.exitQuantity = params.exitMovementItemsAttributes.reduce((sum, a)=> sum+a.quantity,null);
      // params.entryQuantity = params.entryMovementItemsAttributes.reduce((sum, a)=> sum+a.quantity,null);
      var selected = this.indexItems.filter(i => i.id == params.id)[0];
      var index = this.indexItems.findIndex(i=> i.id == params.id);
      // console.log("sel", selected);
      // this.indexItems.remove(selected);
      this.indexItems.splice(index, 1);
      selected.exitQuantity = params.exitMovementItemsAttributes.reduce((sum, a)=> sum+a.quantity,null);
      selected.entryQuantity = params.entryMovementItemsAttributes.reduce((sum, a)=> sum+a.quantity,null);
      this.indexItems.push(selected);
      this.callback();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(params){
      //this.loadServerEntries();
      // console.log('entry', params);
      params.exitQuantity = params.exitMovementItemsAttributes.reduce((sum, a)=> sum+a.quantity,null);
      params.entryQuantity = params.entryMovementItemsAttributes.reduce((sum, a)=> sum+a.quantity,null);
      this.indexItems.push(params);
      this.callback();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(destroyed){
      // this.loadServerEntries();
      // console.log("id", destroyed);
      var index = this.indexItems.findIndex(item => item.id == destroyed.id);
      // console.log("a", index);
      this.indexItems.splice(index, 1);
      // console.log("ss", this.indexItems);
      this.callback();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
    exitStorageAdjustmentOpenAction: function() {
      if (this.$refs.exitStorageAdjustmentNewRef) {
        if (this.$refs.exitStorageAdjustmentNewRef.$refs.baseNew) {
          this.$refs.exitStorageAdjustmentNewRef.$refs.baseNew.openAction();
          this.dialogCancelAction();
        }
      }
    },
    entryStorageAdjustmentOpenAction: function() {
      if (this.$refs.entryStorageAdjustmentNewRef) {
        if (this.$refs.entryStorageAdjustmentNewRef.$refs.baseNew) {
          this.$refs.entryStorageAdjustmentNewRef.$refs.baseNew.openAction();
          this.dialogCancelAction();
        }
      }
    },
    dialogOpenAction: function() {
      // console.log("dialogOpenAction");
    },
    dialogCancelAction: function() {
      // console.log("dialogCancelAction");
      this.dialogModel = false;
    },
  }
};

// const LOAD_ALL_STORAGE_ADJUSTMENTS = gql `
//   query($input: IndexInputObject!) {
//     accountContext {
//       storageAdjustmentsIndex(input: $input){
//         count
//         typeOperators
//         serverFields      
//         stockAdjustments {
//           id
//           code
//           date
//           adjustmentTypeText
//           isStockEntryType
//           storage {
//             name
//           }
//           stockAdjustmentReason {
//             name
//           }
//           canBeDeleted
//           undeletabilityReasons
//         }
//       }
//     }
//   }
// `;

</script>

<style scoped></style>
